<template>
    <j-page>
        <div slot="search" @keydown.enter="searchEvent">
            <el-button type="warning" icon="el-icon-plus" @click="addDgmxEvent">新增</el-button>
            <el-button type="info" icon="el-icon-refresh" @click="resetEvent">刷新</el-button>
        </div>
        <div slot="table">
            <el-table v-loading="tableLoading" :data="tableData" @selection-change="tableSelectionChange" height="100%" stripe>
                <el-table-column type="index" label="序号" align="center" width="50" />
                <el-table-column prop="title" label="图标" show-overflow-tooltip>
                    <j-file style="width: 30px;height: 30px;" slot-scope="{row}" type="card" :src="row.url" :name="row.name" />
                </el-table-column>
                <el-table-column prop="name" label="图标名称" show-overflow-tooltip />
                <el-table-column prop="url" label="图标路径" show-overflow-tooltip />
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click.stop="editDgmxEvent(scope.row)" type="text" class="common-button-edit">编辑</el-button>
                        <el-button @click.stop="delEvent(scope.row)" type="text" class="common-button-del" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!--        新增/编辑-->
        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="400px" top="5%" :close-on-click-modal="false">
            <el-form ref="dgmxDom" :model="dgmxForm" :rules="dgmxRule" :label-width="dgmxFormLabelWidth" @keydown.native.enter="checkDgmxEvent('saveDgmxData')">
                <el-form-item label="图标名称" prop="name">
                    <el-input v-model.trim="dgmxForm.name" placeholder="请输入图标名称" maxlength="10" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="图标图片" prop="url">
                    <j-upload v-model="dgmxForm.url" mode="card" :mime-type-limit="['image/jpeg', 'image/gif', 'image/png']" :count-limit="1" />
                </el-form-item>
            </el-form>
            <template slot="footer">
                <el-button type="primary" @click="checkDgmxEvent('saveDgmxData')" :loading="submitLoad">保存</el-button>
                <el-button @click="showDgmx = false">取消</el-button>
            </template>
        </el-dialog>
    </j-page>
</template>

<script>
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    import DialogMixins from "../../components/JComponents/JPage/mixins/DialogMixins";
    export default {
        name: "AppIconManage",
        mixins: [PageMixins, DialogMixins],
        data() {
            return {
                dgmxForm: {
                    name: '',
                    url: ''
                },
                dgmxRule: {
                    name: [{ required: true, message: '请输入图标名称', trigger: 'blur' }],
                    url: [{ required: true, message: '请选择图标图片', trigger: 'change' }]
                }
            }
        },
        created() {
            this.load()
        },
        methods: {
            async load () {
                // this.tableLoading = true
                // const { data } = await this.$http.get(`/api/iconMaps`).finally(() => {
                //     this.tableLoading = false
                // })
                // if (data.status !== 'yes') return this.$message.warning(data.msg || data.message || `接口异常`)
                // this.tableData = data.data
                // this.tableLoading = false
                this.tableData = [{"iconMapId":11,"url":"icon/acd58907e3db441cab9be204fad39e5c.png&bucketName=grid","name":"实有房屋"},{"iconMapId":12,"url":"icon/ba6bc6ff72e84364bd4e5b70784e4ea5.png","name":"实有人口"},{"iconMapId":13,"url":"icon/b76e792c9471462cb04b39841e8397e1.png","name":"实有单位"},{"iconMapId":14,"url":"/icon/335235c459da4991816d5ea47dae31a4.png","name":"隐患排查"},{"iconMapId":8,"url":"/icon/2be82ab59ae14daea468bb4804c085dc.png","name":"汇总统计"},{"iconMapId":5,"url":"/icon/123a718dfaed40e890e87f00e249d9c7.png","name":"代办任务"},{"iconMapId":6,"url":"icon/27df99524192497f9f8fa207f9f790b2.png","name":"上下班打卡"},{"iconMapId":7,"url":"/icon/3aa778d61afe4dbeb568989257dfc28b.png","name":"格格故事"},{"iconMapId":9,"url":"icon/ca916d5bbfc44079b82c1b7612007304.jpg","name":"请假"},{"iconMapId":10,"url":"icon/02cad2468a894f4080437b71a4a4edfa.png","name":"日常巡查"},{"iconMapId":11,"url":"icon/acd58907e3db441cab9be204fad39e5c.png&bucketName=grid","name":"实有房屋"},{"iconMapId":22,"url":"/icon/5b74edb0fe894c58953fad0b14b48d4b.png","name":"汇总统计"},{"iconMapId":8,"url":"/icon/ffcf676a61e74529b6028c48787e9b57.png","name":"操作指南"},{"iconMapId":9,"url":"icon/ca916d5bbfc44079b82c1b7612007304.jpg","name":"请假"},{"iconMapId":10,"url":"icon/02cad2468a894f4080437b71a4a4edfa.png","name":"日常巡查"},{"iconMapId":15,"url":"/icon/d04fd490da83451f8561a55aeb761685.png","name":"办理中"},{"iconMapId":16,"url":"/icon/e586ff8f3845497ab6d406e8800dfa88.png","name":"待办事项"},{"iconMapId":17,"url":"/icon/b69122d1b0094a209ecfc6f21e0617e7.png","name":"已办结"},{"iconMapId":18,"url":"/icon/0e40796800d5487ca619f9720d7cbb10.png","name":"党群服务"},{"iconMapId":19,"url":"/icon/88c78db8fd014fe5a4b20cb597e20763.png","name":"服务宣传"},{"iconMapId":20,"url":"/icon/a4e7c5dd9bea4e85a7ac7ca6bc8b29f9.png","name":"群众上报"},{"iconMapId":28,"url":"/icon/d3a4b899c3a84cc5b14c2cad88cec8dc.png","name":"供暖问题排查"},{"iconMapId":23,"url":"/icon/ba86bd4e0a784b3da3fc8c193044fd0b.png","name":"实有房屋"},{"iconMapId":41,"url":"icon/8cfa49b00f944054a138cc62d978d1a0.png&bucketName=grid","name":"待上传"},{"iconMapId":61,"url":"icon/481da75931c7407c9d1f724ca7419913.png&bucketName=grid","name":"迁入核查"}]
            },
            async saveDgmxData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'post'
                let url = `/api/iconMaps`
                if (this.dgmxType === 'EDIT') {
                    url = `/api/iconMaps/${this.curItem.iconMapId}`
                    method = 'put'
                }
                const { data } = await this.$http[method](url, this.dgmxForm)
                    .catch(({response}) => { this.$message.error(response.data.msg) })
                    .finally(() => { this.submitLoad = false })
                if (data.status !== 'yes') return this.$message.error(data.msg)
                this.showDgmx = false
                this.$message.success('提交成功')
                this.load()
            },
            delEvent (row) {
                this.$confirm('您确认要删除当前记录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.request({ method: 'delete', url: `/api/iconMaps/${row.iconMapId}`})
                        .then((res) => {
                            if (res.data.status !== 'yes') return this.$message.error(res.data.msg)
                            this.pageUpdate(this.query)
                            this.$message.success('删除成功')
                            this.load && this.load()
                        })
                })
            }
        }
    }
</script>
